/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export enum SignupStepType{
  initial_step = 'initial_step',
  legal_entity_step = 'legal_entity_step',
  subscription_plan_step = 'subscription_plan_step',
  card_info_step = 'card_info_step',
  payment_method_step = 'payment_method_step',
  payment_method_pending_step = 'payment_method_pending_step'
}
